<!-- Data Table Definition -->
<mat-table [dataSource]="data" matSort matSortDisableClear [matSortActive]="fields[0]" matSortDirection="asc"
    [ngStyle]="{'min-width': minTableWidth + 'px'}">

    <!-- Defining our columns -->
    <ng-container *ngFor="let field of fields; let i = index; trackBy: fieldTrackBy" [matColumnDef]="field">
        <ng-container *ngIf="field != 'actions'">
            <ng-container *ngIf="showFilters">
                <mat-header-cell *matHeaderCellDef [mat-sort-header]="field" class="detailCell">
                    {{field}}
                    <filter [data]="data" class="mat-filter" [columnName]="field" dataType="string"></filter>
                </mat-header-cell>
            </ng-container>
            <ng-container *ngIf="!showFilters">
                <mat-header-cell *matHeaderCellDef class="detailCell">
                    {{field}}
                </mat-header-cell>
            </ng-container>
            <mat-cell *matCellDef="let assessmentData; let j = index;" class="detailCell">
                {{assessmentData[field]}}
            </mat-cell>
        </ng-container>
    </ng-container>
    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="detailCell">
            <span translate>
                Actions
            </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let field; let j = index" class="detailCell">
            <tyl-mat-menu id="actionMenu{{j}}" image="actions.png" [iconWidth]="30">
                <!-- <button id="editAssessmentButton" mat-menu-item class="menuItem" (click)="editAssessmentClick(field)">
                    Edit
                </button>
                <button id="deleteStudentButton" mat-menu-item class="menuItem" (click)="deleteAssessmentClick(field)">
                    Delete
                </button> -->
            </tyl-mat-menu>
        </mat-cell>
    </ng-container>
    <!-- </ng-container> -->


    <!-- Row definitions -->
    <mat-header-row *matHeaderRowDef="fields"></mat-header-row>
    <mat-row *matRowDef="let row; let j = index; columns: fields;" matRipple>
    </mat-row>
</mat-table>
